import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";

import { DateSelection } from "../../ecommerce/product";
import { paragraph1, paragraph2, paragraph3 } from "../../utils/styles";
import Money from "../Money";

export const testIdWrapper = "day-pricing-toggle";

interface EcommerceProductDayPricingToggleProps {
  fixedPrice: number;
  openPrice: number;
  selectedDayPricing: DateSelection;
  handleDayPricingChange: (dateSelection: DateSelection) => void;
}

const DATA_DAY_PRICING_TYPE = "dayPricingType";

const EcommerceProductDayPricingToggle: React.FC<
  EcommerceProductDayPricingToggleProps
> = ({ fixedPrice, openPrice, selectedDayPricing, handleDayPricingChange }) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>): void => {
      const dateSelection = event.currentTarget.dataset[
        DATA_DAY_PRICING_TYPE
      ] as DateSelection;
      handleDayPricingChange(dateSelection);
    },
    [handleDayPricingChange],
  );

  const isFixedSelected = selectedDayPricing === DateSelection.FIXED;

  return (
    <ul
      className="list ma0 pa0 w-100 flex justify-center bg-near-white br-pill"
      data-testid={testIdWrapper}
    >
      <li
        className={`relative w-50 br-pill ${
          isFixedSelected ? "z-1 bg-black white" : "bg-near-white"
        }`}
        data-testid="day-pricing-toggle-fixed-date"
      >
        <button
          className={`bg-transparent color-inherit bw0 pointer w-100 h-100 pv2 pv3-ns ph3`}
          onClick={handleClick}
          data-day-pricing-type={DateSelection.FIXED}
          data-testid="day-pricing-toggle-button-fixed-date"
        >
          <span className={`f7 f6-ns ${paragraph1} db ttu`}>
            <FormattedMessage id="prices.fixedDayTitle" />
          </span>
          <span className={`${isFixedSelected ? paragraph2 : paragraph3} db`}>
            <FormattedMessage
              id="prices.startingFrom"
              values={{ value: <Money value={fixedPrice} /> }}
            />
          </span>
        </button>
      </li>
      <li
        className={`relative w-50 br-pill ${
          !isFixedSelected ? "z-1 bg-black white" : "bg-near-white"
        }`}
        data-testid="day-pricing-toggle-open-date"
      >
        <button
          className={`bg-transparent color-inherit bw0 pointer w-100 h-100 pv2 pv3-ns ph3`}
          onClick={handleClick}
          data-day-pricing-type={DateSelection.OPEN}
          data-testid="day-pricing-toggle-button-open-date"
        >
          <span className={`f7 f6-ns ${paragraph1} db ttu`}>
            <FormattedMessage id="prices.openDayTitle" />
          </span>
          <span className={`${!isFixedSelected ? paragraph2 : paragraph3} db`}>
            <Money value={openPrice} />
          </span>
        </button>
      </li>
    </ul>
  );
};

export default EcommerceProductDayPricingToggle;
